'use strict'

import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {calculatePrice, calculatePricePro} from 'yougile-model'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'

export const addPriceRoi = () => {
  const cnt = document.querySelector('.price-roi')
  if (!cnt) {
    return
  }
  const select = (el: string) => cnt.querySelector('.price-roi__' + el)
  const selectAll = (el: string) => {
    const res: HTMLElement[] = []
    const els = cnt.querySelectorAll<HTMLElement>('.price-roi__' + el)
    for (let i = 0; i < els.length; i++) {
      res.push(els[i])
    }
    return res
  }

  const up = (noTracking: boolean) => {
    if (!noTracking) {
      Tracking.send(TrackingEvent.sitePriceRoiInteraction)
    }
    const isPro = (select('tariff') as HTMLSelectElement).value === 'Pro'
    const months = +(select('months') as HTMLSelectElement).value
    const users = +(select('users') as HTMLInputElement).value
    const inc = +(select('inc') as HTMLSelectElement).value
    const salary = +(select('salary') as HTMLInputElement).value

    const getPrice = isPro
      ? calculatePricePro
      : (m: number, u: number) => calculatePrice(m, Math.max(0, u - 10))

    const tot = select('tot')
    const times = selectAll('time')
    const profit = select('profit')
    const daysToProfit = select('days-to-profit')
    const m = select('months') as HTMLSelectElement

    times.forEach(t => (t.textContent = m.options[m.selectedIndex].text))
    const spents = getPrice(months, users)
    tot.textContent = Util.amountToStr(spents)
    const totProfit = Math.round((months * users * salary * 1000 * inc) / 100)
    profit.textContent = Util.amountToStr(totProfit)
    const profitPerDay = ((totProfit / months) * 12) / 365
    const daysToProfitNum = Math.ceil(
      profitPerDay > 0 ? spents / profitPerDay : 0
    )
    daysToProfit.innerHTML = `${daysToProfitNum} ${Lang.getMessages(
      'ru'
    ).severalDaysSuff(daysToProfitNum)}`
  }

  ;['tariff', 'months', 'users', 'inc', 'salary']
    .map(select)
    .forEach(el => el.addEventListener('change', () => up(false)))
  ;['users', 'salary']
    .map(select)
    .forEach(el => el.addEventListener('keyup', () => up(false)))

  up(true)
}
